// extracted by mini-css-extract-plugin
export default {"container":"MyTab_container__necrG","tab":"MyTab_tab__SKY0+","selected":"MyTab_selected__v1JJ-","upload":"MyTab_upload__XH1fY"};